var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.disabled,attrs:{"href":_vm.press.link,"target":_vm.target}},[_vm._v(" "+_vm._s(_vm.press.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }